<template>
  <div class="popup-wrapper">
    <div v-if="has_opener" class="popup-opener">
      <button
        @click.prevent="openPopup()"
        class="fshr-button fshr-button fshr-button--inline"
      >
        {{ opener_text }}
      </button>
    </div>

    <div
      class="side-popup"
      :class="{ opened: this.isOpen }"
      v-if="popup_type == 'side'"
    >
      <div class="side-popup-inner">
        <span class="side-popup-close" @click="closeAndAnnounce">
          <span class="fshr-icon fshr-icon--cross"></span>
        </span>
        <slot></slot>
      </div>
    </div>

    <transition name="fade" v-else-if="popup_type == 'standard'">
      <div
        class="standard-popup"
        :class="{ fullscreen: fullscreen }"
        v-show="this.isOpen"
      >
        <div class="standard-popup-inner">
          <span class="standard-popup-close" @click="closePopup()">
            <span class="fshr-icon fshr-icon--cross"></span>
          </span>

          <slot name="main-header"></slot>
          <slot name="main-content"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
//var popupsOpened = 0; //original popupsOpened - isnt working 

export default {
  name: "Popup",
  props: {
    popupid: {
      default: "test",
      required: true,
      type: String,
    },
    popup_type: {
      default: "standard",
      type: String,
      required: false,
    },
    has_opener: {
      default: false,
      required: false,
      type: Boolean,
    },
    opener_text: {
      default: "Otevřít popup",
    },
    preopen: {
      default: false,
      type: Boolean,
    },
    onOpen: {
      type: Function,
      required: false,
    },
    onClose: {
      type: Function,
      required: false,
    },
    fullscreen: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      popupsOpened: 0,
    };
  },
  methods: {
    openPopup() {
      if (this.popup_type === "side") {
        setTimeout(() => {
          const restOfPage = document.querySelector(".fshr-documentWrapper");
          restOfPage.classList.add("scrollToLeft");
          document.querySelector("body").classList.add("disableChat");
          window.scrollTo(0, 0);
        }, 100);
      }

      if (this.popup_type === "standard") {
      }

      const bd = document.querySelector("body");
      bd.style.overflow = "hidden";
      bd.classList.add("is-popup-opened");

      this.isOpen = true;
      this.popupsOpened++;

      if (this.onOpen) {
        this.onOpen();
      }
    },
    closeAndAnnounce() {
      this.closePopup();
      this.$root.$emit("sidePopupClosed");
    },
    closePopup() {
      const _this = this;

      if (this.popup_type === "side") {
        const restOfPage = document.querySelector(".fshr-documentWrapper");
        restOfPage.classList.remove("scrollToLeft");
        document.querySelector("body").classList.remove("disableChat");
      }

      if (this.popup_type === "standard") {
      }

      var pageType = $("body").attr("data-page-type");
      if ((pageType === 'search' && this.popupid !== 'skimap') || (pageType !== 'search')) {
        const bd = document.querySelector("body");
        bd.style.overflow = "visible";
        bd.classList.remove("is-popup-opened");
      }

      setTimeout(() => {
        _this.isOpen = false;
        this.popupsOpened--;
      }, 100);
      if (this.onClose) {
        this.onClose();
      }
    },
  },
  mounted() {
    const _this = this;
    this.$root.$on("openPopup", (popupid) => {
      if (_this.popupid === popupid) {
        _this.openPopup();
      }
    });

    if (this.preopen) {
      this.openPopup();
    }

    this.$root.$on("closePopup", (popupid) => {
      if (typeof popupid === "undefined") {
        _this.closePopup();
      }

      if (_this.popupid === popupid) {
        _this.closePopup();
      }
    });
  },
};
</script>

<style>
html {
  scroll-behavior: auto;
}

.fshr-documentWrapper {
  transition: all 300ms ease-in-out;
  position: relative;
}

.fshr-documentWrapper:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0);
  z-index: 999;
  pointer-events: none;
  transition: all 300ms ease-in-out;
}

.scrollToLeft {
  /*transform: translateX(-600px);*/
}

.scrollToLeft:after {
  background-color: rgba(0, 0, 0, 0.55);
  pointer-events: all;
}

/* SIDE POPUP */
.side-popup {
  position: fixed;
  right: -100%;
  width: 600px;
  background-color: #ffffff;
  top: 0px;
  bottom: 0px;
  z-index: 9999;
  transition: all 300ms ease-in-out;
}

.side-popup.opened {
  right: 0px;
}

.side-popup-close {
  position: absolute;
  top: 10px;
  left: -44px;
  background-color: white;
  cursor: pointer;
  vertical-align: middle;
  height: 44px;
  width: 44px;
  text-align: center;
  line-height: 44px;
  font-size: 18px;
  color: #9f9f9f;
}

.side-popup-close span:before {
  vertical-align: initial;
}

/* SIDE POPUP */
.standard-popup {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(244, 244, 244, 0.9);
  z-index: 99999;
  transition: all 300ms ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}

.standard-popup .standard-popup-inner {
  padding: 30px;
  max-width: 900px;
  background-color: white;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.5);
  min-width: 400px;
  max-height: 80%;
  overflow-y: auto;
}

.standard-popup.fullscreen .standard-popup-inner {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  padding: 40px;
}

.standard-popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 10px;
  color: #ffffff;
  vertical-align: middle;
  background-color: #003473;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}

.standard-popup-close:hover {
  background-color: red;
}

.standard-popup-heading {
  text-align: center;
  color: #003473;
  margin-bottom: 10px;
}

.standard-popup-subheading {
  text-align: center;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 25px;
}

.popup-opener {
  text-align: center;
  margin: 15px 0px 0px 0px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
